import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useResendTimer } from '../../../../../hooks'
import { FormikForm } from '../../../../Formik'
import { LoginFormBody } from '../../LoginFormBody'
import { LoginFormPhoneVerificationFields } from '../LoginFormPhoneVerificationFields'

import { LOGIN_FORM_PHONE_VERIFICATION_INITIAL_VALUES } from './LoginFormPhoneVerification.constants'
import {
  getLoginFormPhoneVerificationValidationSchema,
  toPrivatePhoneNumber,
} from './LoginFormPhoneVerification.utils'
import { ResendCodeButton } from './ResendCodeButton'
import { ReturnButton } from './ReturnButton'

function LoginFormPhoneVerification({
  getValidationSchema = getLoginFormPhoneVerificationValidationSchema,
  initialValues = LOGIN_FORM_PHONE_VERIFICATION_INITIAL_VALUES,
  isLoading,
  submittedPhoneData,
  onRemoveNotification,
  onResendCode,
  onReturnBackToPhoneNumber,
  onSetNotification,
  onSubmit,
}) {
  const { t } = useTranslation()

  const resendTimer = useResendTimer()

  const validationSchema = getValidationSchema()

  useEffect(() => {
    resendTimer.start()

    return () => {
      resendTimer.stop()
    }
  }, [])

  function handleSuccessResendCode() {
    resendTimer.start()
  }

  return (
    <FormikForm
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <LoginFormBody
        ReturnButton={ReturnButton}
        actionsProps={{
          ...(resendTimer.isFinished
            ? {
                ResendCodeButton,
                resendCodeButtonProps: {
                  onResendCode,
                  onSuccess: handleSuccessResendCode,
                },
              }
            : null),
          isLoading,
          submitText: t('Auth.SignInByPhoneVerifyCodeSubmitBtnKey'),
        }}
        helpText={t('Auth.SignInByPhoneVerifyCodeTextKey', {
          phone: toPrivatePhoneNumber(submittedPhoneData.number),
        })}
        returnButtonProps={{ onClick: onReturnBackToPhoneNumber }}
        onRemoveNotification={onRemoveNotification}
        onSetNotification={onSetNotification}
      >
        <LoginFormPhoneVerificationFields
          resendTimerSecondsLeft={resendTimer.secondsLeft}
          onRemoveNotification={onRemoveNotification}
          onSetNotification={onSetNotification}
        />
      </LoginFormBody>
    </FormikForm>
  )
}

export default LoginFormPhoneVerification
